import React, { forwardRef } from "react";
import { Soft, type SoftProps } from "./Soft";

export type WorkspaceCardProps = SoftProps;

/**
 * The single card pattern for every workspace list (Plugins, Skills,
 * Knowledge, Schedules, Marketplace, Connections, Projects). These cards sit
 * on the solid page, so they use the neumorphic `Soft` surface (extruded soft
 * shadows, no hard border) with consistent padding + the interactive
 * hover-lift / press-inset / focus-ring affordance.
 */
export const WorkspaceCard = forwardRef<HTMLDivElement, WorkspaceCardProps>(
  function WorkspaceCard({ interactive = true, sx, children, ...rest }, ref) {
    return (
      <Soft
        ref={ref}
        interactive={interactive}
        sx={{ p: 2, ...sx }}
        {...rest}
      >
        {children}
      </Soft>
    );
  },
);
